import type { Dict } from "./lv.ts";

export const ru: Dict = {
  "app.title": "Stundio",
  "general.continue": "Продолжить",

  "nav.home": "Главная",
  "nav.week": "Неделя",
  "nav.changes": "Замены",
  "nav.subjects": "Предметы",
  "nav.transit": "Транспорт",
  "nav.settings": "Настройки",
  "nav.group.schedule": "Расписание",
  "nav.group.personal": "Личное",

  "onboarding.title": "Выбери свой класс",
  "onboarding.subtitle": "Расписание и замены — даже без интернета.",

  "onboarding.persona.title": "Выбери свою сторону",
  "onboarding.persona.subtitle": "Настрой расписание под свою роль",
  "onboarding.persona.student.title": "Ученик",
  "onboarding.persona.student.desc": "Хочу видеть уроки своей группы и замены",
  "onboarding.persona.teacher.title": "Преподаватель",
  "onboarding.persona.teacher.desc": "Хочу видеть свои уроки, кабинеты и замены",

  "onboarding.teacher.title": "Выбери преподавателя",
  "onboarding.teacher.subtitle": "Поиск по имени или фамилии",

  "teacher.search": "Поиск преподавателя…",
  "teacher.none": "Преподаватель не найден",
  "teacher.formClass": "Классный руководитель",
  "teacher.cover": "Замена",
  "teacher.coverFor": "Заменяет: {name}",
  "teacher.view.own": "Мои уроки",
  "teacher.view.formClass": "Мой класс",

  "onboarding.language.title": "Выберите язык",
  "onboarding.language.continue": "Продолжить",

  "onboarding.intro.skip": "Пропустить",
  "onboarding.intro.next": "Далее",
  "onboarding.intro.start": "Начать",
  "onboarding.intro.progress": "Шаг знакомства",
  "onboarding.intro.step1.title": "Расписание в одном месте",
  "onboarding.intro.step1.body": "День и неделя наглядно — как в EduPage, только быстрее.",
  "onboarding.intro.step2.title": "Замены видно сразу",
  "onboarding.intro.step2.body":
    "Отменённые, перенесённые и заменённые уроки выделены — ничего не пропустишь.",
  "onboarding.intro.step3.title": "Работает и без интернета",
  "onboarding.intro.step3.body":
    "Расписание хранится на устройстве, поэтому оно доступно даже без сети.",
  "onboarding.intro.step4.title": "Уведомления о важном",
  "onboarding.intro.step4.body":
    "Напоминание перед уроком и сигнал, если поменялись замены — и больше ничего.",

  "class.search": "Поиск класса…",
  "class.none": "Классы не найдены",
  "class.favorites": "Избранное",
  "class.all": "Все классы",
  "class.loading": "Загружаем список классов…",
  "class.favorite.add": "Добавить в избранное",
  "class.favorite.remove": "Убрать из избранного",

  "subgroup.title": "В какой подгруппе {class} ты учишься?",
  "subgroup.subtitle":
    "Этот класс разделён на подгруппы — выбери свою, чтобы видеть только свои уроки.",
  "subgroup.option": "Подгруппа {label}",
  "subgroup.skip": "Пропустить — показывать обе подгруппы",

  "day.today": "Сегодня",
  "day.tomorrow": "Завтра",
  "day.yesterday": "Вчера",
  "day.jumpToday": "К сегодня",
  "day.previousDay": "Предыдущий день",
  "day.nextDay": "Следующий день",
  "day.openCalendar": "Выбрать дату",
  "day.previousMonth": "Предыдущий месяц",
  "day.nextMonth": "Следующий месяц",
  "day.pageHint": "Проведи пальцем влево или вправо, или используй стрелки, чтобы сменить день",
  "day.empty": "Уроков нет",
  "day.emptyHint": "Выходной или праздник?",
  "day.noClass": "Сначала выбери класс",
  "day.changeClass": "Сменить класс",
  "day.noData": "Нет сохранённых данных",
  "day.noDataHint": "Подключись к интернету, чтобы скачать расписание.",
  "week.longBreak": "Большая перемена · {min} мин",
  "week.noSchedule": "Расписания на эту неделю пока нет",
  "week.noScheduleHint":
    "Обычно оно появляется ближе к дате. Потяни вниз, чтобы проверить обновления.",
  "day.stale": "Расписание на эту неделю ещё не опубликовано — показываем прошлое.",
  "day.offline": "Нет подключения к интернету — показываем сохранённое расписание.",
  "day.buildingOther": "Другой корпус: {building}",
  "day.buildingMixed": "Несколько корпусов: {buildings}",
  "home.schedule": "Расписание на день",
  "home.notifyBlocked": "Уведомления выключены — напоминания и оповещения об изменениях не придут.",
  "home.notifyBlockedWeb":
    "Уведомления заблокированы в браузере — включите их в настройках сайта, чтобы получать оповещения.",
  "day.notes": "Объявления",
  "day.allNotes": "Все объявления школы ({count})",
  "day.onlyMyGroup": "Только для моей группы",
  "day.free": "Окно",
  "day.finished": "Уроки закончились",
  "day.now": "Сейчас",
  "day.glance.left": "Осталось {duration}",
  "day.glance.in": "Через {duration}",
  "day.glance.following": "Дальше",
  "day.glance.walk": "Идти в {building}",
  "day.glance.walkFrom": "Переход из {from} в {building}",
  "day.summary.lessons": "Уроков: {count}",
  "day.summary.free": "Окна: {duration}",
  "day.summary.lessonsTooltip": "Всего уроков в этот день",
  "day.summary.freeTooltip": "Общее свободное время между уроками",
  "day.tomorrow.eyebrow": "Следующий учебный день · {weekday}",
  "day.tomorrow.starts": "Начало в {time}",
  "day.tomorrow.changes": "Изменений: {count}",
  "day.tomorrow.open": "Открыть {weekday}: начало в {time}",
  "day.glance.open": "Открыть {title}, {countdown}",
  "day.feedbackPrompt.title": "Есть идея?",
  "day.feedbackPrompt.body": "Расскажи, что добавить или исправить в Stundio.",
  "day.feedbackPrompt.action": "Предложить",
  "day.feedbackPrompt.dismiss": "Закрыть",
  "day.androidBanner.title": "Stundio для Android",
  "day.androidBanner.body":
    "Скачайте приложение для виджетов на главном экране, фоновой синхронизации и офлайн-расписания.",
  "day.androidBanner.action": "Скачать APK",
  "day.androidBanner.dismiss": "Закрыть",
  "day.updatePrompt.title": "Доступно обновление",
  "day.updatePrompt.body": "Доступна новая версия Stundio ({version}).",
  "day.updatePrompt.action": "Обновить",
  "day.updatePrompt.dismiss": "Позже",
  "day.updatePrompt.handoff":
    "Загрузка завершена. Подтвердите установку в окне Android или нажмите «Обновить», чтобы повторить.",
  "day.changesBadge": "{n} изменений",

  "changes.title": "Замены",
  "changes.filter.myClass": "Моя группа",
  "changes.filter.myChanges": "Мои изменения",
  "changes.filter.all": "Вся школа",
  "changes.absentTeachers": "Сегодня отсутствуют",
  "changes.emptyForClass": "Изменений нет",
  "changes.emptyForClassHint": "У вашей группы уроки идут по обычному расписанию",
  "changes.emptyAll": "Нет зарегистрированных изменений",
  "changes.emptyAllHint": "Техникум не публиковал изменений на этот день",
  "changes.otherGroupsHaveChanges": "Сегодня есть {n} изменений для других групп",
  "changes.viewOtherGroups": "Смотреть все изменения",
  "changes.searchPlaceholder": "Поиск по группе, предмету или преподавателю…",
  "changes.searchNoResults": "Ничего не найдено",
  "changes.count": "{n} изменений",
  "changes.badge": "{n} изменений",
  "changes.notesFromSchool": "Объявления техникума",
  "changes.rvtWebsite": "Сайт RVT",

  "week.previousWeek": "Предыдущая неделя",
  "week.nextWeek": "Следующая неделя",
  "week.buildingDays": "{building}: {days}",
  "week.overview.title": "Обзор",
  "week.overview.lessons": "{n} уроков",
  "week.overview.lessonsUp": "+{n} по сравнению с прошлой неделей",
  "week.overview.lessonsDown": "{n} по сравнению с прошлой неделей",
  "week.overview.lessonsSame": "Столько же, сколько на прошлой неделе",
  "week.overview.changes": "{n} изменений",
  "week.overview.changesNone": "Без изменений",
  "week.overview.busiestLabel": "Самый загруженный день",
  "week.overview.lightestLabel": "Самый лёгкий день",

  "share.week": "Поделиться неделей",
  "share.working": "Создаём изображение…",
  "share.error": "Не удалось создать изображение",
  "share.title": "Расписание {name}",
  "share.message":
    "{name} расписание {period} \nХотите сделать использование EduPage удобнее? Загляните на: https://bit.ly/stundio",
  "share.image.classTeacher": "Классный руководитель",
  "share.image.appLabel": "Удобный EduPage на телефоне",
  "share.language.title": "На каком языке поделиться?",
  "share.language.sync": "Синхронизировать изображение с языком приложения",
  "share.language.continue": "Продолжить",

  "lesson.teacher": "Преподаватель",
  "lesson.room": "Кабинет",
  "lesson.period": "Урок",
  "lesson.group": "Группа",
  "lesson.building": "Корпус",
  "lesson.was": "Было",
  "lesson.fromSchool": "От школы",
  "lesson.note": "Объявление",
  "lesson.close": "Закрыть",

  "status.cancelled": "Отменён",
  "status.moved": "Перенесён",
  "status.substituted": "Замена",
  "status.room_change": "Другой кабинет",
  "status.added": "Дополнительный урок",

  "sync.syncing": "Обновляем…",
  "sync.offline": "Офлайн",
  "sync.error": "Не удалось обновить",
  "sync.never": "Ещё не обновлялось",
  "sync.updated": "Обновлено {time}",
  "sync.refresh": "Обновить",
  "sync.pull": "Потяни, чтобы обновить",
  "sync.release": "Отпусти, чтобы обновить",
  "sync.toast": "Обновлено",

  "time.inMinutes": "через {n} мин",
  "time.minutesLeft": "осталось {n} мин",
  "time.startsNow": "начинается",

  "subjects.title": "Предметы",
  "transit.title": "Транспорт",
  "transit.plan.title": "Мой маршрут",
  "transit.plan.description":
    "Укажите начальную точку и пункт назначения. Маршрут откроется в Google Maps.",
  "transit.plan.home": "Откуда",
  "transit.plan.homePlaceholder": "Домашний адрес",
  "transit.plan.useLocation": "Использовать моё местоположение",
  "transit.plan.savedHome": "Начальная точка из настроек: {address}",
  "transit.plan.homeMissing":
    "Добавьте домашний адрес в настройках или используйте текущее местоположение.",
  "transit.plan.destination": "Куда",
  "transit.plan.destinationPlaceholder": "Адрес или название места",
  "transit.plan.transitDuration": "Транспорт и пересадки (минуты)",
  "transit.plan.walkDuration": "Пешком до остановки (минуты)",
  "transit.plan.nextLesson": "Следующий урок: {subject}, в {time}",
  "transit.plan.class": "урок",
  "transit.plan.leaveAt": "Выйти примерно в {time}",
  "transit.plan.leaveHint": "Учитывает указанное время пешком до остановки и в транспорте.",
  "transit.plan.noLesson": "Сегодня у выбранной группы больше нет занятий.",
  "transit.plan.findRoute": "Найти маршрут на общественном транспорте",
  "transit.plan.destinationNeeded": "Укажите пункт назначения, чтобы найти маршрут.",
  "transit.plan.mapsNote": "Google Maps покажет доступные маршруты и время отправления.",
  "transit.plan.mapsKeyNeeded": "Для встроенной карты Google Maps нужна настройка приложения.",
  "transit.plan.mapTitle": "Маршрут общественного транспорта в Google Maps",
  "transit.plan.goToSchool": "В школу",
  "transit.plan.goHome": "Домой",
  "transit.plan.schoolDay": "Первый урок в {start} · {building} · последний урок до {end}",
  "transit.plan.main": "главном корпусе",
  "transit.plan.tic": "Центре технологий и инноваций",
  "transit.plan.startsAtSeven": "Маршруты в школу появятся с 7:00.",
  "transit.plan.fromTo": "Маршрут",
  "transit.plan.currentLocation": "Ваше местоположение",
  "transit.plan.homeAddress": "Дом ({address})",
  "transit.plan.homeward": "домой",
  "transit.plan.noHome": "домашний адрес не указан",
  "transit.plan.refreshLocation": "Обновить GPS",
  "transit.plan.refreshRoutes": "Обновить маршруты",
  "transit.plan.lessonsAtTic": "Занятия проходят в Центре технологий и инноваций.",
  "transit.plan.alreadyAtSchool": "Вы уже у школы.",
  "transit.plan.loadingRoutes": "Ищем маршруты общественного транспорта…",
  "transit.plan.routesKeyNeeded":
    "Чтобы показать маршруты, добавьте в приложение ключ Google Routes API.",
  "transit.plan.routesUnavailable": "Не удалось загрузить маршруты. Попробуйте ещё раз позже.",
  "transit.plan.noRoutes": "Для этого маршрута не найден общественный транспорт.",
  "transit.plan.option": "Вариант {number}",
  "transit.plan.leaveAround": "Выйти из дома около {time}",
  "transit.plan.walk": "Пешком",
  "transit.plan.locationUnavailable": "На этом устройстве местоположение недоступно.",
  "transit.plan.locationLoading": "Определяем местоположение…",
  "transit.plan.locationReady": "Для маршрута используется ваше местоположение.",
  "transit.plan.locationDenied":
    "Не удалось определить местоположение. Проверьте разрешение браузера.",
  "transit.live.title": "Транспорт Риги в реальном времени",
  "transit.live.description":
    "Смотрите на карте, где находятся транспортные средства, и проверяйте время прибытия на остановки.",
  "transit.live.show": "Показать карту",
  "transit.live.source": "Карта Rīgas satiksme",
  "transit.live.openFull": "Открыть на весь экран",
  "transit.live.frameTitle": "Карта транспорта Rīgas satiksme в реальном времени",
  "transit.destinations.title": "Сохранённые адреса",
  "transit.destinations.description": "Сохранённые адреса служат началом маршрута до RVT.",
  "transit.destinations.currentLocation": "От текущего местоположения",
  "transit.destinations.rvtAddress": "Пункт назначения: RVT · {address}",
  "transit.destinations.openGoogleMaps": "Открыть Google Maps",
  "transit.destinations.nameLabel": "Название места",
  "transit.destinations.namePlaceholder": "Школа, работа, друзья…",
  "transit.destinations.addressLabel": "Адрес",
  "transit.destinations.addressPlaceholder": "Улица, дом, город",
  "transit.destinations.add": "Добавить адрес",
  "transit.destinations.remove": "Удалить {label}",
  "transit.destinations.locationUnavailable": "На этом устройстве местоположение недоступно.",
  "transit.destinations.gettingLocation": "Определяем местоположение…",
  "transit.destinations.locationDenied": "Разрешите доступ к местоположению, чтобы построить маршрут от него.",
  "transit.destinations.plannerTitle": "Планировщик маршрутов Rīgas satiksme",
  "transit.destinations.plannerDescription": "Планировщик открыт для адреса: {destination}.",
  "transit.destinations.backToMap": "Назад к карте",
  "transit.live.locationNote":
    "Чтобы показать ваше местоположение, нажмите кнопку геолокации на карте и разрешите доступ, если браузер запросит его.",
  "subjects.perWeek": "{n}× в неделю",
  "subjects.teachers": "Учителя",
  "subjects.empty": "Нет предметов",
  "subjects.emptyHint": "Предметы появятся после загрузки расписания.",
  "subjects.note.placeholder": "Заметка по предмету…",
  "subjects.note.save": "Сохранить",
  "subjects.note.badge": "Есть заметка",

  "settings.title": "Настройки",
  "settings.commute": "Дорога в школу",
  "settings.commute.home": "Домашний адрес",
  "settings.commute.homePlaceholder": "Введите адрес или название места",
  "settings.commute.homeHint":
    "Сохраняется только на этом устройстве и используется для планирования маршрута.",
  "settings.persona.student": "Ученик",
  "settings.persona.teacher": "Преподаватель",
  "settings.identity.sheetTitle": "Выбор роли",
  "settings.identity.confirm": "Подтвердить",
  "settings.class": "Моя группа",
  "settings.change": "Изменить",
  "settings.building": "Корпус",
  "settings.buildingAuto": "Автоматически",
  "settings.subgroup": "Подгруппа",
  "settings.subgroupAll": "Обе",
  "settings.customization": "Персонализация",
  "settings.theme": "Оформление",
  "settings.language": "Язык",
  "settings.share": "Публикация",
  "settings.shareLanguage": "Язык изображения",
  "settings.mergeLessons": "Объединять одинаковые уроки",
  "settings.mergeLessonsHint":
    "Показывает предмет, повторяющийся подряд, как один длинный блок в просмотре недели.",
  "settings.movedOnTarget": "Показывать перенесённые уроки в новый день",
  "settings.movedOnTargetHint":
    "Урок, перенесённый на другой день, отображается в этот день, а не в прежний.",
  "view.options": "Параметры вида",
  "settings.showTime": "Показать время",
  "settings.showTimeHint": "Показывает время начала и конца каждого урока рядом с его номером.",
  "settings.notifications": "Уведомления",
  "settings.showSubjectsTab": "Вкладка «Предметы»",
  "settings.showSubjectsTabHint":
    "Показывает вкладку предметов в нижнем меню, рядом с настройками.",
  "settings.notifyLessonReminder": "Напоминание об уроке",
  "settings.notifyLessonReminderHint": "Уведомлять перед началом следующего урока.",
  "settings.notifyLessonReminderOff": "Выкл",
  "settings.notifySubstitutionChanges": "Изменения в расписании",
  "settings.notifySubstitutionChangesHint":
    "Уведомлять об изменениях в расписании на сегодня или завтра.",
  "settings.notifyNewTimetable": "Новое расписание",
  "settings.notifyNewTimetableHint":
    "Уведомлять, когда школа публикует расписание на новую неделю.",
  "settings.notifyAppUpdates": "Обновления приложения",
  "settings.notifyAppUpdatesHint": "Уведомлять о выходе новой версии приложения.",
  "settings.notifyExactAlarmDenied":
    "Система запрещает точные будильники — напоминания могут опаздывать. Разрешите «Будильники и напоминания».",
  "settings.notifyPermissionDenied": "Уведомления заблокированы в настройках системы.",
  "settings.notifyOpenSettings": "Открыть настройки",
  "settings.notificationsWebNotice":
    "Офлайн-напоминания и уведомления доступны в приложении для Android. В веб-версии изменения обновляются при открытии.",
  "settings.notificationsIosPwaRequired":
    "Чтобы получать уведомления на iPhone, сначала добавьте Stundio на экран «Домой».",
  "settings.notificationsLessonRemindersNativeNotice":
    "Напоминания перед каждым уроком доступны в приложении Android. Уведомления об изменениях расписания работают через Web Push.",
  "notification.lessonReminder.title": "{subject} через {minutes} мин",
  "notification.changed.title": "Изменения в расписании",
  "notification.changed.body": "В сегодняшнем расписании есть изменения.",
  "notification.cover.title": "Новая замена",
  "notification.cover.body": "Вам назначена замена",
  "notification.newTimetable.title": "Новое расписание",
  "notification.newTimetable.body": "Опубликовано новое расписание с {date}.",
  "notification.update.title": "Доступно обновление",
  "notification.update.body": "Stundio {version} готово к загрузке.",
  "widget.now": "Сейчас",
  "widget.next": "Далее",
  "widget.done": "Уроков сегодня больше нет",
  "widget.noClass": "Выбери класс",
  "widget.noData": "Открой Stundio, чтобы обновить",
  "widget.minutesLeft": "ещё {minutes} мин",
  "widget.minutesUntil": "через {minutes} мин",
  "settings.data": "Данные",
  "settings.analytics": "Анонимная статистика использования",
  "settings.analyticsHint":
    "Помогает понять, какие функции используются. Без файлов cookie и личных данных.",
  "settings.about": "О приложении",
  "settings.aboutText":
    "Неофициальное приложение. Данные берутся из публичного расписания pikcrvt.edupage.org и принадлежат школе.",
  "settings.currentVersion": "Текущая версия: {version}",
  "settings.checkForUpdatesAction": "Проверить",
  "settings.checkingForUpdates": "Проверка…",
  "settings.upToDate": "У вас последняя версия",
  "settings.updateAvailable": "Доступна новая версия ({version})",
  "settings.updateAction": "Скачать",
  "settings.updateDownloading": "Загрузка… {percent}%",
  "settings.updateError": "Не удалось обновить: {message}",
  "settings.updateFailed": "Не удалось обновить",
  "whatsNew.title": "Что нового",
  "whatsNew.eyebrow": "Версия {version}",
  "whatsNew.done": "Понятно",
  "whatsNew.history": "Предыдущие версии",
  "whatsNew.empty": "Списка изменений пока нет.",
  "settings.whatsNew": "Что нового",
  "settings.whatsNewHint": "Изменения в этой и предыдущих версиях",
  "settings.dangerZone": "Опасная зона",
  "settings.resetData": "Сбросить все данные",
  "settings.resetDataHint": "Удаляет заметки и сбрасывает настройки.",
  "settings.resetDataConfirmTitle": "Сбросить все данные?",
  "settings.resetDataConfirmBody":
    "Все заметки будут удалены, а настройки сброшены до исходных. Приложение вернётся к начальной настройке.",
  "settings.resetDataConfirmButton": "Сбросить все данные",
  "settings.resetDataCancelButton": "Отмена",
  "feedback.sheet.title": "Предложить функцию",
  "feedback.sheet.messageLabel": "Твоя идея или предложение",
  "feedback.sheet.messagePlaceholder": "Что Stundio стоит добавить или улучшить?",
  "feedback.sheet.emailLabel": "Твой email (необязательно)",
  "feedback.sheet.emailPlaceholder": "Если хочешь получить ответ",
  "feedback.sheet.submit": "Отправить предложение",
  "feedback.sheet.submitting": "Отправка…",
  "feedback.sheet.successTitle": "Спасибо за идею!",
  "feedback.sheet.successBody": "Твоё предложение отправлено. Спасибо за участие!",
  "feedback.sheet.bugTitle": "Сообщить об ошибке",
  "feedback.sheet.bugMessageLabel": "Что произошло?",
  "feedback.sheet.bugMessagePlaceholder": "Опишите, что пошло не так и чего вы ожидали…",
  "feedback.sheet.bugSubmit": "Отправить отчёт",
  "feedback.sheet.bugSubmitting": "Отправка…",
  "feedback.sheet.bugSuccessTitle": "Отчёт отправлен!",
  "feedback.sheet.bugSuccessBody": "Спасибо за сообщение! Мы во всём разберёмся.",
  "feedback.sheet.close": "Закрыть",
  "feedback.sheet.error": "Не удалось отправить. Проверь подключение к интернету.",
  "feedback.sheet.attachScreenshot": "Прикрепить скриншот",
  "feedback.sheet.removeScreenshot": "Удалить скриншот",
  "feedback.sheet.screenshotTooLarge": "Изображение слишком большое (макс. 5 МБ)",
  "settings.madeBy": "Dmytro Polizhai сделал с ❤︎",

  "theme.system": "Как в системе",
  "theme.light": "Светлое",
  "theme.dark": "Тёмное",

  "customization.title": "Персонализация",
  "customization.theme": "Оформление",
  "customization.accent": "Акцентный цвет",
  "customization.accent.hint": "Цвет для выделений — сегодняшней даты, выбранной опции.",
  "customization.accent.reset": "По умолчанию",
  "customization.lessonStyle": "Карточки уроков",
  "customization.lessonStyle.hint": "Как цвет предмета показан в списке дня.",
  "customization.lessonStyle.outline": "Контур",
  "customization.lessonStyle.filled": "Заливка",
  "customization.radius": "Скругление углов",
  "customization.radius.compact": "Компактное",
  "customization.radius.balanced": "Среднее",
  "customization.radius.standard": "Стандартное",
  "customization.radius.rounder": "Более круглое",
  "customization.elevation": "Глубина карточек",
  "customization.elevation.soft": "Мягкая",
  "customization.elevation.bold": "Выразительная",
  "customization.reduceMotion": "Меньше анимации",
  "customization.reduceMotion.hint": "Отключает переходы и анимации в приложении.",
  "customization.subjectColors": "Цвета предметов",
  "customization.subjectColors.enabled": "Цветовая маркировка предметов",
  "customization.subjectColors.enabled.hint":
    "Если выключено, каждый предмет показан одним нейтральным цветом в списке дня и на неделе.",
  "customization.subjectColors.hint":
    "Нажми на цвет, чтобы назначить его; нажми «Авто», чтобы вернуть цвет по умолчанию.",
  "customization.subjectColors.reset": "Авто",
  "customization.subjectColors.custom": "Свой цвет",
  "customization.subjectColors.lightness": "Яркость",
  "customization.subjectColors.empty": "Выбери класс, чтобы настроить цвета предметов.",
  "customization.subjectColors.hint.teacher":
    "Это предметы, которые ты преподаёшь. Нажми на цвет, чтобы назначить его; нажми «Авто», чтобы вернуть цвет по умолчанию.",
  "customization.subjectColors.empty.teacher":
    "Выбери себя как преподавателя, чтобы настроить цвета своих предметов.",
  "customization.preview.subject": "Пример предмета",
  "customization.reset": "Сбросить настройки",

  "iphoneInstall.title": "Добавьте Stundio на экран «Домой»",
  "iphoneInstall.subtitle":
    "Используйте Stundio как полноценное приложение на iPhone — во весь экран, без лишних панелей и без интернета.",
  "iphoneInstall.step1": "Нажмите кнопку «На экран „Домой“» ниже или кнопку Поделиться в Safari",
  "iphoneInstall.step2": "В меню выберите «На экран „Домой“»",
  "iphoneInstall.action": "Добавить на экран «Домой»",
  "teacherAnnouncement.title": "Stundio для учителей",
  "teacherAnnouncement.headline": "Теперь доступно и учителям",
  "teacherAnnouncement.subtitle":
    "Учителя теперь могут использовать Stundio для просмотра своего расписания и замен.",
  "teacherAnnouncement.step1.title": "Перейдите в настройки",
  "teacherAnnouncement.step1.desc": "Откройте вкладку настроек",
  "teacherAnnouncement.step2.title": "Измените профиль",
  "teacherAnnouncement.step2.desc": "Выберите профиль учителя",
  "teacherAnnouncement.step3.title": "Выберите свое имя",
  "teacherAnnouncement.step3.desc": "Найдите себя в списке, чтобы получить расписание",
  "teacherAnnouncement.tryIt": "Попробовать",
  "teacherAnnouncement.done": "Понятно",
  "settings.teacherShare": "Функции для учителей",
  "settings.teacherShareHint": "Показать уведомление о функциях для учителей",
  "iphoneInstall.dismiss": "Продолжить в браузере",
  "settings.iphoneInstall": "Добавить на экран «Домой»",
  "settings.iphoneInstallHint": "Установить Stundio как приложение на iPhone",

  "settings.group.schedule": "Расписание",
  "settings.group.appearance": "Внешний вид и язык",
  "settings.identityHint": "Чьё расписание показывать на главной, в неделе и в виджете.",
  "settings.subgroupHint": "Скрывает уроки другой подгруппы из дня и недели.",
  "settings.buildingHint": "Показывать расписание только одного корпуса или обоих сразу.",
  "settings.themeHint": "Светлое, тёмное или как в системе телефона.",
  "settings.languageHint":
    "Язык интерфейса. Предметы и замены остаются на латышском, как в EduPage.",
  "settings.customizationHint": "Цвета предметов, акцент, стиль и скругление карточек.",
  "settings.shareLanguageHint":
    "На каком языке подписаны картинка недели и сообщение, которыми вы делитесь.",
  "settings.shareLangFollowApp": "Как в приложении",
  "settings.sync": "Синхронизация",
  "settings.syncHint":
    "Расписание хранится на телефоне и работает без сети. Нажмите, чтобы обновить.",
  "settings.updates": "Обновления",
  "settings.updatesHint": "Проверяет и устанавливает новую версию прямо из приложения.",
  "settings.version": "Версия",
  "settings.versionHint": "Версия приложения на этом устройстве.",
  "settings.reportIssueRow": "Сообщить об ошибке",
  "settings.reportIssueHint": "Опишите проблему — автор получит её вместе с версией приложения.",
  "settings.suggestFeatureRow": "Предложить идею",
  "settings.suggestFeatureHint": "Что добавить или поменять в приложении.",
  "settings.notifyPermissionDeniedTitle": "Уведомления запрещены",
  "settings.notifyExactAlarmTitle": "Напоминания могут опаздывать",
  "settings.notificationsWebTitle": "Уведомления в приложении Android",
  "settings.minutes": "{minutes} мин",
  "settings.reminderOption": "За {minutes} мин до урока",

  "error.title": "Что-то пошло не так",
  "error.hint": "Не удалось загрузить этот экран.",
  "error.retry": "Попробовать снова",
};
